import { observer } from "mobx-react";
import React from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { IRoom } from "../../../models/room/Room";
import styles from "./followControl.css";

interface Props {
  room: IRoom;
}

export const FollowControl = observer((props: Props) => {
  const { room } = props;
  const onClick = room.isFollowedByMe ? () => room.unfollow() : () => room.follow();
  const title = intl.formatMessage(
    room.isFollowedByMe ? "conversation.unfollow" : "conversation.follow"
  );
  const idName = room.isFollowedByMe ? "unfollow" : "follow";

  return (
    <div className={styles["follow-control"]} onClick={onClick} id={idName + "_control"}>
      {title}
    </div>
  );
});
